<template>
    <div>
        {{configured}}/{{points.length}}
        <i class="fa fa-fw" :class="icon == 'success' ? 'fa-check-circle text-success' : 'fa-exclamation-triangle text-danger'"></i>
    </div>
</template>

<script>
/* eslint-disable */

export default {
    props: {
        points: {
            type: Array,
            required: true
        },
        group: {
            type: Object,
            required: true
        },
        idx: {
            type: Number,
            required: true
        }
    },
    data: function() {
        return {
            
        }
    },
    components: {},
    methods: {

    },
    computed: {
        icon() {
            if (this.configured == this.points.length) {
                return 'success'
            }
            return 'danger'
        },
        color() {
            if (this.configured == this.points.length) {
                return 'green'
            }
            return 'red'
        },
        configured() {
            return this.points.map( (item) => item.list_pickups).map( (item) => item[this.idx]).filter( (it) => it.activity_group.id == this.group.id && ( it.pickup != null  || it.service == false ) ).length
        }
    }
}
</script>
